import { type KeyboardEvent } from 'react';

/*
    Backspace on an empty multiple Autocomplete removes the last value, with nothing visible to show
    what went. Every picker here lists its values below the input, so a per-chip delete is the only
    way to detach one. `defaultMuiPrevented` is how MUI lets a caller cancel its own key handling.
*/
export default function preventBackspaceRemoval(event: KeyboardEvent) {
    if (event.key === 'Backspace') {
        (event as unknown as { defaultMuiPrevented?: boolean }).defaultMuiPrevented = true;
    }
}
